import { runningClientSide } from '@benzinga/utils';
import { OPTIMIZELY_SCRIPT_ID, OPTIMIZELY_SCRIPT_SRC } from './constants';

export function injectOptimizelyScript(): void {
  if (!runningClientSide()) return;
  if (document.getElementById(OPTIMIZELY_SCRIPT_ID)) return;
  const scriptElement = document.createElement('script');
  scriptElement.src = OPTIMIZELY_SCRIPT_SRC;
  scriptElement.setAttribute('id', OPTIMIZELY_SCRIPT_ID);
  scriptElement.onerror = (event: Event | string) => {
    if (typeof event === 'object' && event?.type === 'error') {
      console.error('Failed to inject Optimizely script');
    }
  };
  document.head.appendChild(scriptElement);
}

export function removeOptimizelyScript(): void {
  if (!runningClientSide()) return;
  const script = document.getElementById(OPTIMIZELY_SCRIPT_ID);
  if (script) script.remove();
}
